module.exports = __webpack_public_path__ + "img/icon_account.f463c490.svg";